import { render } from "./CommentaryIntroduction.vue?vue&type=template&id=0c8b72eb&ts=true"
import script from "./CommentaryIntroduction.vue?vue&type=script&lang=ts"
export * from "./CommentaryIntroduction.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__